import * as angular from 'angular';

import { uiDecimal } from '../ui-decimal';

import { labelInput } from './label-input.directive';
import { labelInputTextareaAutosize } from './editor/text-area-autosize.directive';
import { labelInputBehavior } from './editor/input-behavior.directive';
import { labelInputFormatterDirective } from './editor/input-formatter.directive';
import { labelInputEditor } from './editor/editor.directive';

import 'bootstrap-css-only';
import './style.less';
import { ngxLabelWrapperModule } from '@go-modules/components/label-input/label-wrapper';

export const labelInputModule = angular.module('labelInput', [
	uiDecimal,
	ngxLabelWrapperModule
])
	.directive('labelInputEditor', labelInputEditor)
	.directive('labelInputBehavior', labelInputBehavior)
	.directive('labelInputFormatter', labelInputFormatterDirective)
	.directive('labelInputTextareaAutosize', labelInputTextareaAutosize)
	.directive('labelInput', labelInput)
	.name;
